import { PropsWithChildren, ReactElement } from 'react';
import styled from 'styled-components';
import { Tooltip, Position, SvgIcon, theme } from '..';
import { RadioListProvider } from './RadioListContext';

const RadioListElement = styled.div<{ removeItemSpace: boolean }>`
  & > * {
    margin-bottom: ${({ removeItemSpace }) => (removeItemSpace ? '0' : '20px')};
  }
`;

const Header = styled.div<{ headerMaxWidth: string }>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  max-width: ${({ headerMaxWidth }) => (headerMaxWidth ? headerMaxWidth : '100%')};
  & span {
    width: 16px;
    height: 16px;
  }
`;

interface Props {
  caption?: string;
  tooltip?: boolean;
  tooltipTitle?: string;
  tooltipPosition?: Position;
  tooltipHtml?: ReactElement;
  headerMaxWidth?: string;
  /**
   * Optional - Radio buttons will be displayed compactly.
   * @default false
   */
  compacted?: boolean;
  removeItemSpace?: boolean;
}

export const RadioList = ({
  caption,
  tooltip,
  headerMaxWidth,
  children,
  compacted,
  tooltipTitle,
  tooltipHtml,
  tooltipPosition,
  removeItemSpace,
}: PropsWithChildren<Props>) => (
  <RadioListProvider compacted={compacted}>
    {(caption || tooltip) && (
      <Header headerMaxWidth={headerMaxWidth}>
        {caption}
        {tooltip && (
          <Tooltip position={tooltipPosition} title={tooltipTitle} html={tooltipHtml}>
            <SvgIcon name="circle-question" size="16" color={theme.designToken.primary700} />
          </Tooltip>
        )}
      </Header>
    )}
    <RadioListElement removeItemSpace={removeItemSpace} role="radiogroup">
      {children}
    </RadioListElement>
  </RadioListProvider>
);
